module.exports = __webpack_public_path__ + "static/media/Light-Through-The-Cracks.251da837.jpg";